import React from "react";

type SideImageProps = { hide?: boolean };

export const SideImage = ({ hide = false }) => {
    return (
        <>
            {!hide ? (
                <div className="col-sm-4 d-none d-md-block">
                    <img src="/images/question-woman.svg" alt="O que deseja fazer?" style={{ maxWidth: "100%" }} />
                </div>
            ) : (
                ""
            )}
        </>
    );
};
